<template>
	<div class="welcome"></div>
</template>

<script>
export default {
  name: 'welcome'
}
</script>

<style scoped>
	.welcome{height: 100vh;width: 100%;overflow: hidden;text-align: center;background: url(../assets/img/bg.jpg);position: absolute;z-index: -1;top: 0;left: 0;}
</style>



// WEBPACK FOOTER //
// welcome.vue?f1947b78